import { useSetting } from "@faire/marketplace-lib/settings/__internal__/useSetting";
import { HOLIDAY_SPEND_CHALLENGE_CURRENT_DATE_OVERRIDE } from "@faire/web-api--source/indigofair/settings/HOLIDAY_SPEND_CHALLENGE_CURRENT_DATE_OVERRIDE";

/* This setting is used just for testing purposes. */
export const useSettingHolidaySpendChallengeCurrentDateOverride = (): string =>
  useSetting(
    HOLIDAY_SPEND_CHALLENGE_CURRENT_DATE_OVERRIDE,
    "2025-10-02T00:00:00.000-04:00"
  );
